import {createMuiTheme} from '@material-ui/core';

import palette from './palette';
import typography from './typography';
import overrides from './overrides';

const theme = createMuiTheme({
    palette,
    typography,
    overrides,
    zIndex: {
        appBar: 1200,
        drawer: 1100,
    },
    shadows: [
        'none',
        '0px 2px 4px rgba(17, 24, 39, 0.06), 0px 4px 6px rgba(17, 24, 39, 0.1)',
        '0px 4px 6px rgba(17, 24, 39, 0.06), 0px 10px 15px rgba(17, 24, 39, 0.1)',
        '0px 10px 20px rgba(17, 24, 39, 0.06), 0px 15px 25px rgba(17, 24, 39, 0.1)',
        '0px 15px 25px rgba(17, 24, 39, 0.06), 0px 20px 30px rgba(17, 24, 39, 0.1)',
        '0px 20px 30px rgba(17, 24, 39, 0.06), 0px 25px 35px rgba(17, 24, 39, 0.1)',
        '0px 25px 35px rgba(17, 24, 39, 0.06), 0px 30px 40px rgba(17, 24, 39, 0.1)',
        '0px 25px 35px rgba(17, 24, 39, 0.06), 0px 30px 40px rgba(17, 24, 39, 0.1)',
        '0px 25px 35px rgba(17, 24, 39, 0.06), 0px 30px 40px rgba(17, 24, 39, 0.1)',
        '0px 25px 35px rgba(17, 24, 39, 0.06), 0px 30px 40px rgba(17, 24, 39, 0.1)',
        '0px 25px 35px rgba(17, 24, 39, 0.06), 0px 30px 40px rgba(17, 24, 39, 0.1)',
        '0px 25px 35px rgba(17, 24, 39, 0.06), 0px 30px 40px rgba(17, 24, 39, 0.1)',
        '0px 25px 35px rgba(17, 24, 39, 0.06), 0px 30px 40px rgba(17, 24, 39, 0.1)',
        '0px 25px 35px rgba(17, 24, 39, 0.06), 0px 30px 40px rgba(17, 24, 39, 0.1)',
        '0px 25px 35px rgba(17, 24, 39, 0.06), 0px 30px 40px rgba(17, 24, 39, 0.1)',
        '0px 25px 35px rgba(17, 24, 39, 0.06), 0px 30px 40px rgba(17, 24, 39, 0.1)',
        '0px 25px 35px rgba(17, 24, 39, 0.06), 0px 30px 40px rgba(17, 24, 39, 0.1)',
        '0px 25px 35px rgba(17, 24, 39, 0.06), 0px 30px 40px rgba(17, 24, 39, 0.1)',
        '0px 25px 35px rgba(17, 24, 39, 0.06), 0px 30px 40px rgba(17, 24, 39, 0.1)',
        '0px 25px 35px rgba(17, 24, 39, 0.06), 0px 30px 40px rgba(17, 24, 39, 0.1)',
        '0px 25px 35px rgba(17, 24, 39, 0.06), 0px 30px 40px rgba(17, 24, 39, 0.1)',
        '0px 25px 35px rgba(17, 24, 39, 0.06), 0px 30px 40px rgba(17, 24, 39, 0.1)',
        '0px 25px 35px rgba(17, 24, 39, 0.06), 0px 30px 40px rgba(17, 24, 39, 0.1)',
        '0px 25px 35px rgba(17, 24, 39, 0.06), 0px 30px 40px rgba(17, 24, 39, 0.1)',
        '0px 25px 35px rgba(17, 24, 39, 0.06), 0px 30px 40px rgba(17, 24, 39, 0.1)',
    ],
});

export default theme;
